import { AppleMac, Globe, SmartphoneDevice, Windows } from 'iconoir-react';
import { AndroidIcon, ChromeIcon } from '@/components/shared-ui/custom-icons';
import * as m from '@/paraglide/messages';
import type { ComponentType, SVGProps } from 'react';

export function SqueezeDevices() {
  return (
    <section className='border-y border-steel-120 bg-mist-385 px-4 py-14 sm:px-7'>
      <div className='mx-auto max-w-[1000px] text-center'>
        <div className='text-[12.5px] font-bold tracking-wide text-azure-455 uppercase'>
          {m.funnel_sq_anywhere_eyebrow()}
        </div>
        <h2 className='mt-2 mb-3 text-[28px] font-extrabold tracking-tight text-balance sm:text-[34px]'>
          {m.funnel_sq_anywhere_heading()}
        </h2>
        <p className='mx-auto mb-7 max-w-[560px] text-base leading-relaxed text-steel-880'>
          {m.funnel_sq_anywhere_body()}
        </p>
        <div className='mx-auto flex max-w-[780px] flex-wrap justify-center gap-3.5'>
          <DeviceTile Icon={Globe} label={m.funnel_device_web()} />
          <DeviceTile Icon={AppleMac} label={m.funnel_device_mac()} />
          <DeviceTile Icon={Windows} label={m.downloads_dropdown_windows()} />
          <DeviceTile
            Icon={SmartphoneDevice}
            label={m.funnel_device_iphone()}
          />
          <DeviceTile Icon={AndroidIcon} label={m.funnel_device_android()} />
          <DeviceTile Icon={ChromeIcon} label={m.funnel_device_chrome()} />
        </div>
      </div>
    </section>
  );
}

function DeviceTile({
  Icon,
  label,
}: {
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
}) {
  return (
    <div className='flex w-[100px] flex-col items-center gap-2 rounded-[10px] border border-steel-120 bg-mist-165 px-2 py-4 text-center text-[13px] font-semibold sm:w-[112px]'>
      <Icon aria-hidden className='size-7 text-steel-700' strokeWidth={1.6} />
      <span className='flex min-h-10 items-center leading-tight'>{label}</span>
    </div>
  );
}
